import { Component, input, output, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { LocalizationService } from '../../../core/localization/localization.service';
import { InfoHintComponent } from '../../../shared/design-system/info-hint.component';
import { FORM_LAYOUT_TYPES, FormLayoutType } from '../../../shared/dynamic-form/form-schema.models';

@Component({
  standalone: true,
  selector: 'ain-form-builder-layout-picker',
  imports: [ButtonModule, InfoHintComponent],
  template: `
    <section class="layout-picker card">
      <div class="header">
        <h3>{{ t('dynamic.builder.layoutPicker.title') }}</h3>
        <ain-info-hint
          [titleKey]="'dynamic.builder.layoutPicker.infoTitle'"
          [descriptionKey]="'dynamic.builder.layoutPicker.infoDescription'"
          [bulletKeys]="['dynamic.builder.layoutPicker.infoBullet']" />
      </div>
      <p class="intro">{{ t('dynamic.builder.layoutPicker.intro') }}</p>
      <div class="layout-grid">
        @for (layout of layouts; track layout.value) {
          <button type="button" class="layout-card" (click)="selectLayout(layout.value)">
            <i [class]="layout.icon"></i>
            <strong>{{ t(layout.labelKey) }}</strong>
            <span>{{ t(layout.descriptionKey) }}</span>
          </button>
        }
      </div>
    </section>
  `,
  styles: [`
    .layout-picker { display: grid; gap: 16px; }
    .header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
    .header h3 { margin: 0; }
    .intro { margin: 0; color: #475569; }
    .layout-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      gap: 12px;
    }
    .layout-card {
      display: grid;
      gap: 8px;
      text-align: start;
      padding: 16px;
      border: 1px solid #cbd5e1;
      border-radius: 12px;
      background: #fff;
      cursor: pointer;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
    }
    .layout-card:hover {
      border-color: #0f766e;
      box-shadow: 0 4px 14px rgba(15, 118, 110, 0.12);
    }
    .layout-card i { font-size: 1.25rem; color: #0f766e; }
    .layout-card strong { color: #0f172a; }
    .layout-card span { color: #64748b; font-size: 0.875rem; line-height: 1.4; }
    .card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px;
      background: #fff;
    }
  `]
})
export class FormBuilderLayoutPickerComponent {
  private readonly localization = inject(LocalizationService);

  readonly disabled = input(false);
  readonly layoutSelected = output<FormLayoutType>();

  readonly layouts = FORM_LAYOUT_TYPES;

  selectLayout(type: FormLayoutType): void {
    if (this.disabled()) {
      return;
    }
    this.layoutSelected.emit(type);
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
